import ContactUsWithWarehouses from "@/components/us-website/ContactUsWithWarehouses/ContactUsWithWarehouses";
import React from "react";
import LocationWrapper from "@/components/us-website/LocationWrapper";
import MetaTags from "@/components/seo/meta-tags";

function index() {
  return (
    <LocationWrapper>
      <MetaTags
        title="Contact Us | Elchemy US Chemical Distribution"
        description="Partner with Elchemy for custom chemical manufacturing tailored to personal care and fragrance needs. Reliable, scalable, and regulation-ready."
        includeAlternateLink={true}
      />
      <ContactUsWithWarehouses />
    </LocationWrapper>
  );
}

export default index;
